import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "./reports.css"
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { BsFiletypeCsv } from "react-icons/bs";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';

const MaterialReceive = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currencyPrecision, setPrecision] = useState();
    const [PoList, setPOlist] = useState();
    const [grnList, setGrnList] = useState();
    const [cost1, setCost1] = useState();
    const [cost2, setCost2] = useState();
    const [categoryList, setCategorylist] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [SupplierList, setSuppliers] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const gridRef = useRef();


    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [toDate, setToDate] = useState(getCurrentLocalDatetime);
    const [fromDate, setFromDate] = useState(getCurrentLocalDatetime);

    const [formData, setFormData] = useState({
        costCenter1: [{ label: 'Select Cost Center 1', value: '0' }],
        costCenter2: [{ label: 'Select Cost Center 2', value: '0' }],
        category: [{ label: 'Select Category', value: '' }],
        GrnNo: [{ label: 'GRN No', value: '' }],
        PONo: [{ label: 'PO No', value: '' }],
        itemNo: [{ label: 'Item No', value: '' }],
        ItemDescription: [{ label: 'Item Description', value: '' }],
        SupplierName: [{ label: 'Select Supplier', value: '' }],
    });

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const params = new URLSearchParams();
                params.append('dropdownTypes', 'MRPoNumbers,MRGRNNumbers,MRSuppliers,MRCostCenter1,MRCostCenter2,MRItemCatmast');
                const res = await apiService.getApiParamater('REPORTS_MULTI', `?${params.toString()}`);
                setPOlist(res?.data?.dropdowns?.MRPoNumbers);
                setGrnList(res?.data?.dropdowns?.MRGRNNumbers);
                setCost1(res?.data?.dropdowns?.MRCostCenter1);
                setCost2(res?.data?.dropdowns?.MRCostCenter2);
                setSuppliers(res?.data?.dropdowns?.MRSuppliers);
                setCategorylist(res?.data?.dropdowns?.MRItemCatmast);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
        getItems()
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const handleClearFilters = () => {
        setFormData({
            costCenter1: [{ label: 'Select Cost Center 1', value: '0' }],
            costCenter2: [{ label: 'Select Cost Center 2', value: '0' }],
            category: [{ label: 'Select Category', value: '' }],
            GrnNo: [{ label: 'GRN No', value: '' }],
            PONo: [{ label: 'PO No', value: '' }],
            itemNo: [{ label: 'Item No', value: '' }],
            ItemDescription: [{ label: 'Item Description', value: '' }],
            SupplierName: [{ label: 'Select Supplier', value: '' }],
        });
        setFromDate(getCurrentLocalDatetime)
        setToDate(getCurrentLocalDatetime)
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const Comparison = [
        { headerName: 'Item Code', field: 'itemCode', suppressMovable: true, width: 140 },
        { headerName: 'Item Description', field: 'itemDescription', suppressMovable: true, width: 250 },
        { headerName: 'Category', field: 'catName', suppressMovable: true, width: 150 },
        { headerName: 'Stock Type', field: 'stockType', suppressMovable: true, width: 100, },
        {
            headerName: 'Trans Date', field: 'tranDate', suppressMovable: true, width: 140, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'UOM', field: 'uom', suppressMovable: true, width: 150 },
        { headerName: 'Qty', field: 'qty', suppressMovable: true, width: 150 },
        {
            headerName: 'Unit Price', field: 'unitPrice', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 0)
        },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 0)
        },
        { headerName: 'Vendor Name', field: 'vendorName', suppressMovable: true, width: 250 },
        { headerName: 'GRN NO', field: 'grnNo', suppressMovable: true, width: 150 },
        { headerName: 'POrder No', field: 'pOrderNo', suppressMovable: true, width: 150 },
        { headerName: 'Warehouse', field: 'warehouse', suppressMovable: true, width: 150 },
        { headerName: 'Cost Center1', field: 'costCenter1', suppressMovable: true, width: 150 },
        { headerName: 'Cost Center2', field: 'costCenter2', suppressMovable: true, width: 150 },

    ];
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('CostCenter1', formData.costCenter1.label || "All");
            params.append('CostCenter2', formData.costCenter2.label || "All");
            params.append('POrderNo', formData.PONo.label || "All");
            params.append('GRN', formData.GrnNo.label || "All");
            params.append('Supplier', formData.SupplierName?.label || "All");
            params.append('ItemCode', formData.itemNo.label || "All");
            params.append('ItemDesc', formData.ItemDescription.label || "All");
            params.append('Category', formData.category.label || "All");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('FromDate', moment(fromDate).format("DD-MMM-YYYY") || "");
            params.append('ToDate', moment(toDate).format("DD-MMM-YYYY") || "");
            const res = await apiService.getApiParamater('GET_MATERIAL_RECEIVE', `?${params.toString()}`);
            setRowData(res?.data?.result || [])
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'GrnReport.csv'
        });
    }, []);
    const handleFromDate = (e) => {
        setFromDate(e.target.value);
    }
    const handleToDate = (e) => {
        setToDate(e.target.value);
    }
    const handleItemChange = (selectedOption) => {
        setFormData({
            ...formData,
            itemNo: selectedOption ? { label: selectedOption.value.itemNo, value: selectedOption.value } : null,
            ItemDescription: selectedOption ? { label: selectedOption.value.itemDescription, value: selectedOption.value } : null,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    return (
        <div className='p-4'>
            <div className='gridBg m-0' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row' >
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.SupplierName}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'SupplierName', value: selectedOption })}
                            options={SupplierList?.map((supl) => ({ value: supl, label: supl?.text }))}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.GrnNo}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'GrnNo', value: selectedOption })}
                            options={grnList?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.PONo}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'PONo', value: selectedOption })}
                            options={PoList?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                </div>
                <div className='row my-2'>
                    <div className='col' >
                        <input
                            type='datetime-local'
                            className="form-Input w-100"
                            value={fromDate}
                            name="fromDate"
                            onChange={handleFromDate}
                            placeholder='From  Date '
                        />
                    </div>
                    <div className='col'>
                        <input
                            type='datetime-local'
                            className="form-Input w-100"
                            placeholder='To  Date '
                            value={toDate}
                            name="toDate"
                            onChange={handleToDate}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.costCenter1}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter1', value: selectedOption })}
                            options={cost1?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.itemNo}
                            options={itemOptions}
                            loadOptions={loadOptions}
                            onChange={selectedOption => handleItemChange(selectedOption)}
                            defaultOptions={itemOptions}
                            onMenuScrollToBottom={loadMoreOptions}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.category}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                            options={categoryList?.map((Stock) => ({ value: Stock, label: Stock?.text }))}
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.costCenter2}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter2', value: selectedOption })}
                            options={cost2?.map((rec) => ({ value: rec, label: `${rec?.text}` }))}
                        />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.ItemDescription}
                            options={descriptionOptions}
                            loadOptions={loadDescOptions}
                            onChange={selectedOption => handleItemChange(selectedOption)}
                            className="w-100 p-0"
                            defaultOptions={descriptionOptions}
                            onMenuScrollToBottom={loadMoreDescOptions}
                        />
                    </div>
                    <div className='col'>
                        <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Search</div>
                        </div>
                    </div>
                    <div className='col'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Material Raceived Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                {/* <DropdownItem onClick={onBtExcelExport} className='gap-3 d-flex center'><LiaFileExcel/><div>Export Excel</div></DropdownItem> */}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            columnDefs={Comparison}
                            ref={gridRef}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default MaterialReceive;